<div class="machines-wrapper">
  <app-machine-list></app-machine-list>
</div>